import { render, staticRenderFns } from "./ButtonAlbum.vue?vue&type=template&id=0a21b415&scoped=true&"
import script from "./ButtonAlbum.vue?vue&type=script&lang=js&"
export * from "./ButtonAlbum.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAlbum.vue?vue&type=style&index=0&id=0a21b415&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a21b415",
  null
  
)

export default component.exports